import './App.css';
import ThemeContainer from './Theme';
import { Provider } from "react-redux";
import store from './Redux/store';
import WagmiWrapper from './Views/Components/WagmiWrapper';
import { GoogleOAuthProvider } from '@react-oauth/google';

const GOOGLE_CLIENT_ID = '1007232355550-sd4cucu3r1scub29s1o1nco2ku149225.apps.googleusercontent.com';
function App() {
  return (
    <Provider store={store}>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
         <WagmiWrapper>
      <ThemeContainer />
         </WagmiWrapper>
         </GoogleOAuthProvider>
    </Provider>
  );
}

export default App;
